"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EcommerceCartDataSourceEnum;
(function (EcommerceCartDataSourceEnum) {
    EcommerceCartDataSourceEnum["default"] = "default";
    EcommerceCartDataSourceEnum["disabled"] = "disabled";
    EcommerceCartDataSourceEnum["iows"] = "IOWS";
    EcommerceCartDataSourceEnum["cartApi"] = "CartApi";
    EcommerceCartDataSourceEnum["chinaCartApi"] = "ChinaCartApi";
    EcommerceCartDataSourceEnum["nifApi"] = "NifApi";
    EcommerceCartDataSourceEnum["roig"] = "roig";
})(EcommerceCartDataSourceEnum || (EcommerceCartDataSourceEnum = {}));
exports.default = EcommerceCartDataSourceEnum;
//# sourceMappingURL=EcommerceCartDataSourceEnum.js.map